module.exports = __webpack_public_path__ + "media/images/pc/staffs/mv_hair_makeup@3x-4f695397933441159bac8086dcbf0d43.webp";